import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Card, Container, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { FormProvider, RHFTextField } from '../components/hook-form';
import { AuthService } from '../Services/auth.service';

const LoginSchema = Yup.object().shape({
  password: Yup.string().required('Mật khẩu không được để trống'),
  newPassword: Yup.string().required('Mật khẩu mới không được để trống'),
  conformPassword: Yup.string()
    .required('Xác nhận mật khẩu không được để trống')
    .oneOf([Yup.ref('newPassword'), null], 'Mật khẩu không khớp'),
});

const ChangePassword = () => {
  const { enqueueSnackbar } = useSnackbar();
  const methods = useForm({
    resolver: yupResolver(LoginSchema),
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleSubmitPressed = (data) => {
    AuthService.ChangePassword(data)
      .then(() => enqueueSnackbar('Đổi mật khẩu thành công', { variant: 'success' }))
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }));
  };
  return (
    <Container maxWidth="lg">
      <FormProvider methods={methods} onSubmit={handleSubmit(handleSubmitPressed)}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Card sx={{ width: { md: 350, xs: 1 }, p: 2 }}>
            <Typography mb={2} sx={{ textAlign: 'center' }} variant="h4">
              Đổi mật khẩu
            </Typography>
            <RHFTextField type="password" name="password" label="Mật khẩu cũ" />
            <RHFTextField type="password" style={{ marginTop: 20 }} name="newPassword" label="Mật khẩu mới" />
            <RHFTextField type="password" style={{ marginTop: 20 }} name="conformPassword" label="Xác nhận mật khẩu" />
            <LoadingButton
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              sx={{ mt: 2 }}
              loading={isSubmitting}
            >
              Đổi mật khẩu
            </LoadingButton>
          </Card>
        </Box>
      </FormProvider>
    </Container>
  );
};

export default ChangePassword;
